'use es6';

import { createSelector } from 'reselect';
export const getPerformanceDataCheck = state => state.performanceDataCheck;
export const getPerformanceDataCheckStatus = createSelector([getPerformanceDataCheck], data => data.status);
export const getHasNoPerformanceData = createSelector([getPerformanceDataCheck], ({
  data
}) => data.get('total') === 0);